export default __webpack_public_path__ + "static/media/interaction.1f0b2734.svg";